
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/google-ads-services",
      function () {
        return require("private-next-pages/services/google-ads-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/google-ads-services"])
      });
    }
  